const SET_CART_ITEMS = "SET_CART_ITEMS";
const REMOVE_ITEM_FROM_CART = "REMOVE_ITEM_FROM_CART";
const SET_PAY_PAL_PAYMENT_STATUS = "SET_PAY_PAL_PAYMENT_STATUS";

export { SET_CART_ITEMS, REMOVE_ITEM_FROM_CART, SET_PAY_PAL_PAYMENT_STATUS };
